import { ContentItem } from '@walkme/types';
import { Action, AllActionsTypes } from '..';
import { ICCUser, INotificationScheduling, ISegment, IVisualDesignData, NotificationTypeEnum, PreviewExtraData, UniqueId } from '../notifications';
import { IDependencies } from '../properties';

export type PublishedNotificationsList = {
  timeStamp: Date;
  notifications: Array<IPublishedNotification>;
  segments?: ISegment[];
  pollingInterval?: number;
};

export interface IPublishedNotification extends ContentItem {
  id: number;
  type: 'communication-center-notification';
  notificationType: NotificationTypeEnum; //(type)
  description: string; //message
  resourceId?: string;
  user?: IPublishNotificationUser;
  systemId?: UniqueId;
  readonly audiencesIds: string[];
  readonly endUsersIds?: string[];
  readonly dependencies?: IDependencies[];
  readonly segments?: Pick<ISegment, 'id' | 'label'>[];
  readonly scheduling?: IPublishNotificationScheduling;
  readonly images: string[];
  readonly buttons: IPublishedNotificationButton[];
}

export type IPublishNotificationUser = Pick<ICCUser, 'id'>;

export interface IPublishedNotificationDesign {
  timeStamp: Date;
  id: string;
  visualDesignData: IVisualDesignData;
}

export interface IPublishNotificationScheduling extends INotificationScheduling {
  publishedAt?: Date;
  startAt?: Date;
  endAt?: Date;
}

export interface IPublishedPreview {
  settings: PublishedNotificationsList;
  visualDesign: IPublishedNotificationDesign;
  previewExtraData: PreviewExtraData;
}

export interface IPublishedNotificationButton {
  id: string;
  label: string;
  action: Action;
  type: AllActionsTypes;
  text?: string;
}

export enum PUBLISH_SCOPE {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  COPY_ACCOUNT = 'COPY_ACCOUNT',
  DELETE_ACCOUNT = 'DELETE_ACCOUNT',
}

export interface PublishSNSMessage {
  systemId: string;
  environmentId?: string;
  url?: string;
  scope: PUBLISH_SCOPE;
  notificationsIds?: string[];
  newNotification?: IPublishedNotification;
  user: ICCUser;
  enabledPush?: boolean;
}
